import { useMemo } from "react";

// English comments as requested.
function isValidHexColor(value) {
    return /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(value);
}

function hexToRgb(hex) {
    if (!hex || !isValidHexColor(hex)) return null;
    const clean = hex.replace("#", "");
    const hasAlpha = clean.length === 8;

    const r = parseInt(clean.slice(0, 2), 16);
    const g = parseInt(clean.slice(2, 4), 16);
    const b = parseInt(clean.slice(4, 6), 16);
    const a = hasAlpha ? parseInt(clean.slice(6, 8), 16) / 255 : 1;

    return { r, g, b, a };
}

function getReadableTextColor(hex) {
    const rgb = hexToRgb(hex);
    if (!rgb) return "#0f172a";

    const { r, g, b } = rgb;
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? "#0f172a" : "#ffffff";
}

export default function DepartmentBadge({ name, colorHex, className = "", title }) {
    const safeName = (name || "").trim() || "—";
    const hasColor = typeof colorHex === "string" && isValidHexColor(colorHex);

    console.log("Rendering DepartmentBadge:", {
        name: safeName,
        colorHex,
        hasColor,
    });

    const styles = useMemo(() => {
        if (!hasColor) return null;
        return {
            backgroundColor: colorHex,
            color: getReadableTextColor(colorHex),
        };
    }, [hasColor, colorHex]);

    // If no color, render plain text only (no badge)
    if (!hasColor) {
        return (
            <span className={className} title={title || safeName}>
                {safeName}
            </span>
        );
    }

    // If color exists, render badge
    return (
        <span
            className={`inline-flex items-center px-3 py-1 text-sm font-medium rounded-full ${className}`}
            style={styles}
            title={title || safeName}
        >
            {safeName}
        </span>
    );
}
